import { AnyObjectSchema } from 'yup';
import { Grid } from '@mui/material';
import { Form, Formik, FormikValues } from 'formik';
import { FormPart } from '@modules/shared/components/FormPart';
import { IFormFieldConfig } from '@shared/components/FormFieldsConstructor';
import { Modal } from '@shared/components/modals/Modal';
import { CancelButton, SaveButton } from '@shared/inputs/Buttons';
import { PageWrapper } from '@shared/styledComponents';
import { LocalTabContent } from '@styles/CommonStyles';
import { ModalFormFooter } from '@styles/ModalStyles';

interface TableModalProps<T> {
  isOpen: boolean;
  onSubmit: (data: T) => Promise<void>;
  onClose: () => void;
  editingData: T;
  formConfig: IFormFieldConfig[];
  isSubmitting?: boolean;
  validationSchema?: AnyObjectSchema;
  saveButtonText?: string;
  cancelButtonText?: string;
  dialogWidth?: string;
  title?: string;
  hideBackdrop?: boolean;
  resetPosition?: number;
}

export const TableModal = <T extends FormikValues>({
  isOpen,
  onSubmit,
  onClose,
  editingData,
  validationSchema,
  formConfig,
  resetPosition,
  hideBackdrop = false,
  isSubmitting = false,
  saveButtonText = 'Save',
  cancelButtonText = 'Cancel',
  dialogWidth = '40vw',
  title = 'Add New',
}: TableModalProps<T>) => (
  <Modal hideBackdrop={hideBackdrop} resetPosition={resetPosition} open={isOpen} title={title} dialogWidth={dialogWidth} onClose={onClose}>
    <Formik initialValues={editingData} validationSchema={validationSchema} onSubmit={onSubmit}>
      {() => (
        <Form>
          <PageWrapper>
            <LocalTabContent style={{ height: 'auto' }}>
              <Grid container spacing={12}>
                <Grid item md={12}>
                  <FormPart config={formConfig} />
                </Grid>
              </Grid>
            </LocalTabContent>
          </PageWrapper>

          <ModalFormFooter>
             <CancelButton label={cancelButtonText} onClick={onClose} />
            <SaveButton label={saveButtonText}  isLoading={isSubmitting} />
          </ModalFormFooter>
        </Form>
      )}
    </Formik>
  </Modal>
);
